//
// FieldLabel
//
// A text-input in code style.

import { observer } from 'mobx-react-lite'
import { FieldMetadata } from '.'
import { ItemTitle } from '../../../components'

export const FieldLabel = observer(function FieldLabel({
    field,
    worksheet,
    inline,
    metadata,
}) {
    if (!field || !worksheet) return null

    let Label = <ItemTitle item={field} />

    let BeforeLabel
    let AfterLabel
    if (metadata) {
        const metadataArray = [...metadata]
        BeforeLabel = metadataArray.map(([name, value], index) => {
            return value === 'before_label' ? (
                <div
                    key={name + '.' + index}
                    className="ws-metaslot ws-metaslot-before-label"
                >
                    <FieldMetadata
                        metadataname={name}
                        metadatafield={field.metadata.get(name)}
                        worksheet={worksheet}
                    />
                </div>
            ) : null
        })
        AfterLabel = metadataArray.map(([name, value], index) => {
            return value === 'after_label' ? (
                <div
                    key={name + '.' + index}
                    className="ws-metaslot ws-metaslot-after-label"
                >
                    <FieldMetadata
                        metadataname={name}
                        metadatafield={field.metadata.get(name)}
                        worksheet={worksheet}
                    />
                </div>
            ) : null
        })
        metadataArray.forEach(([name, value]) => {
            if (value === 'replace_label') {
                Label = (
                    <FieldMetadata
                        metadataname={name}
                        metadatafield={field.metadata.get(name)}
                        worksheet={worksheet}
                    />
                )
            }
        })
    }

    return (
        <>
            {BeforeLabel}
            <div key={'label'} className="ws-metaslot-label">
                {Label}
            </div>
            {AfterLabel}
        </>
    )
})
